import BoxInfo from '@/components/boxInfo/boxInfo';
import { DataGridAction, DataGridColumn } from '@/components/dataGrid/entities/types';
import { convertDataGridActionsToDataTableActions } from '@/components/dataGrid/utils/convertDataGridActionsToDataTableActions';
import { convertDataGridColumnsToDataTableColumns } from '@/components/dataGrid/utils/convertDataGridColumnsToDataTableColumns';
import ShowHide from '@/components/showHide';
import Status from '@/modules/move/components/status/Status';
import { MOVE_ACTION_TRANSLATED_REVERSE } from '@/modules/move/entities/constants/move';
import { MoveNormalized, MoveReponseNormalized } from '@/modules/move/entities/interfaces/move';
import { CountBeneficiaryStatus } from '@/modules/move/views/countBeneficiaryStatus/countBeneficiaryStatus';
import { useHistoryNavigator } from '@/navigation';
import ICONS from '@/shared/entities/constants/icons';
import React, { useState } from 'react';
import { Button, DataTable } from 'vkit/lib/components';

export const moveListColumnOptions: Record<string, DataGridColumn<MoveNormalized, object>> = {
  name: {
    headerName: 'Nome do arquivo',
    field: 'name',
    width: '400px',
  },
  createdBy: {
    headerName: 'Criado por',
    field: 'user.name',
    width: '200px',
  },
  type: {
    headerName: 'Tipo',
    field: 'type',
    width: '100px',
  },
  provider: {
    headerName: 'Fornecedor',
    field: 'provider',
    width: '100px',
  },
  status: {
    headerName: 'Status',
    render: ({ status }: MoveNormalized) => <Status label={status} />,
    width: '100px',
    align: 'center',
  },
  uploadedAt: {
    headerName: 'Criado em',
    field: 'uploadedAt',
    formatData: 'dateTime',
  },
};

export type MoveListColumnKey = keyof typeof moveListColumnOptions;

interface MoveListLineProps {
  elevation?: number;
  move: MoveNormalized;
  columns: MoveListColumnKey[];
  actionsByItem?: DataGridAction<MoveNormalized>[];
  loading?: boolean;
}

export const MoveListLine: React.FC<MoveListLineProps> = ({
  elevation,
  columns,
  actionsByItem,
  loading,
  move,
}) => {
  const navigate = useHistoryNavigator();
  const dataTableColumns = columns.map(
    (columnKey) =>
      moveListColumnOptions[columnKey] as DataGridColumn<MoveReponseNormalized, object>,
  );
  const [showCountByStatus, setShowCountByStatus] = useState(false);

  return (
    <BoxInfo elevation={elevation} margin={0}>
      <DataTable
        columns={convertDataGridColumnsToDataTableColumns({
          dataGridColumns: dataTableColumns,
        })}
        action={
          actionsByItem &&
          convertDataGridActionsToDataTableActions({
            contentHeader: move.provider === 'Bradesco' && (
              <Button
                key={showCountByStatus ? ICONS.ARROW_UP : ICONS.ARROW_DOWN}
                size='xLarger'
                color='light'
                icon={showCountByStatus ? ICONS.ARROW_UP : ICONS.ARROW_DOWN}
                iconColor='light'
                rounded
                onClick={() => setShowCountByStatus(!showCountByStatus)}
                invertColor
              />
            ),
            dataGridActions: actionsByItem,
            navigate: (route) => navigate.push(route),
          })
        }
        data={[move]}
        isLoading={Boolean(loading)}
        showPagination={false}
        elevation={0}
        outlined={false}
      />

      <ShowHide visible={showCountByStatus} transition='slideToDown'>
        <CountBeneficiaryStatus type={MOVE_ACTION_TRANSLATED_REVERSE[move.type]} move={move} />
      </ShowHide>
    </BoxInfo>
  );
};
